export default "__VITE_ASSET__CHpMZsuh__"